<template>
    <div class="card mt-16">
        🙃 Nothing to show here.
    </div>
</template>

<script>
    export default {
        name: "EmptyState"
    }
</script>

<style scoped>

</style>
